import { api } from "./api";

export function trackView(path) {
  if (localStorage.getItem("oic_esclusa") === "1") return;
  api.post("/track", { path, referrer: document.referrer || "" }).catch(() => {});
}
